module.exports = __webpack_public_path__ + "img/Interest-sailing.3884a7a6.svg";